export default {
  name: 'DropdownSeparator',
};
